import { render, staticRenderFns } from "./ItemSlot.vue?vue&type=template&id=55d99623&scoped=true"
import script from "./ItemSlot.vue?vue&type=script&lang=js"
export * from "./ItemSlot.vue?vue&type=script&lang=js"
import style0 from "./ItemSlot.vue?vue&type=style&index=0&id=55d99623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d99623",
  null
  
)

export default component.exports